export default "__VITE_ASSET__DsI$4B6x__"